<template>
  <div style="margin-top: 1%; padding-bottom: 2%">
    Dear A. Jones,<br /><br />

    Today is the third time I've caught Joseph playing computer games during
    work hours in the last 2 weeks, even though we have a bunch of work to do.
    Also, he still hasn't completed the assignment I gave him last week, even
    though I've pointed out to him several times that it's urgent. At first I
    turned a blind eye, but now I've told him that I'll pass this on to you.<br /><br />

    Regards<br />
    Riley Smith
  </div>
</template>

<script>
import "./styles.css";

export default {
  props: {
    parentFunction: Function,
  },
};
</script>
